import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { Building, CheckCircle, Clock, DollarSign, Inbox,  MapPin, Package, Phone, Loader2,  Timer, User, X, CheckCircle2, Eye } from "lucide-react";
// Note: Icons are from lucide-react, as in the original RFQs.js. Adjust if using a different library.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faFilePdf , faMapMarkerAlt ,faFileInvoice, faLink ,faSearch } from '@fortawesome/free-solid-svg-icons';

// Assuming imageurl is defined elsewhere, e.g., const imageurl = "https://your-image-url/";
import {Loader} from '../Loader/Loader';
import Search from '../Components/Search';
import Pagination from '../Components/Pagination';
import { Msg200or201, Msg204, Msg400, Msg401, Msg403, Msg500 } from '../Messages/Messages';

import { FaStore } from "react-icons/fa";
import { decryptData } from "../../utils/storageCrypto";

const OrdersTable = () => {
    const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [error, setError] = useState(null);
const imageurl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;
const [selectedGroups, setSelectedGroups] = useState([]);
const [showCancelPopup, setShowCancelPopup] = useState(false);
const [showSlotPopup, setShowSlotPopup] = useState(false);
const [slotDate, setSlotDate] = useState("");
const [slotTime, setSlotTime] = useState("");
const [activeGroup, setActiveGroup] = useState(null);
const [orderId, setOrderId] = useState(null);
const [shiftPopupVisible, setShiftPopupVisible] = useState(false);
const [selectedGroupForShift, setSelectedGroupForShift] = useState(null);
const [shiftToValue, setShiftToValue] = useState("");
const [billPopup, setBillPopup] = useState(false);
const [billData, setBillData] = useState(null);
const [editBill, setEditBill] = useState(false);
const [billNumber, setBillNumber] = useState("");
const searchTypes = ["Order Number", "Status", "Customer Name"];
const [searchChips, setSearchChips] = useState(() => {
  const saved = localStorage.getItem('ordersSearchChips');
  return saved ? JSON.parse(saved) : [];
});
const [searchType, setSearchType] = useState("");
const [searchQuery, setSearchQuery] = useState("");
const [paginatedOrders, setPaginatedOrders] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10;
const [persistedSearchType, setPersistedSearchType] = useState(''); 
const [persistedSearchQuery, setPersistedSearchQuery] = useState('');
const [showPopup, setShowPopup] = useState(false);
const [popupType, setPopupType] = useState("");
const [popupMessage, setPopupMessage] = useState("");



 const [deliveryGroups, setDeliveryGroups] = useState([]);
const [generatedDeliveryLink, setGeneratedDeliveryLink] = useState(null);
const [generateLinkLoading, setGenerateLinkLoading] = useState(false);
const [copiedDeliveryLink, setCopiedDeliveryLink] = useState(false);
const [showShareLinkPopup, setShowShareLinkPopup] = useState(false);
const shareLinkInputRef = useRef(null);
const API_BASE = process.env.REACT_APP_FORE_BRICKBUCKET + 'customer/salesorder';

const notBilledGroups = deliveryGroups.filter(
  g => !g.sub_orders?.some(sub => sub.billing_status === "Billed")
);

const notBilledGroupIds = notBilledGroups.map(g => g._id);

// ✅ Select All is checked ONLY when all NOT-BILLED groups are selected
const isSelectAllChecked =
  notBilledGroupIds.length > 0 &&
  notBilledGroupIds.every(id => selectedGroups.includes(id));




useEffect(() => {
  localStorage.setItem('ordersSearchChips', JSON.stringify(searchChips));
}, [searchChips]);

const handleGroupSelection = (groupId) => {
  setSelectedGroups(prev => {
    let updated;

    if (prev.includes(groupId)) {
      updated = prev.filter(id => id !== groupId);
    } else {
      updated = [...prev, groupId];
    }

    const allNotBilledSelected =
      notBilledGroupIds.length > 0 &&
      notBilledGroupIds.every(id => updated.includes(id));

    if (allNotBilledSelected) {
      return updated.filter(id => notBilledGroupIds.includes(id));
    }

    return updated;
  });
};



const BackToLoginPage = () => {
    console.log("Back To Login Page");
    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/bb');
  };

  const closePopup = () => {
    setShowPopup(false);
  };
  
const Retry = () => {
  // Implement retry logic, e.g., refetch data
  fetchOrders();
  setShowPopup(false);
};
// OPEN CANCEL POPUP
const openCancelPopup = (group) => {
  setActiveGroup(group);
  setShowCancelPopup(true);
};

// CLOSE CANCEL POPUP
const closeCancelPopup = () => {
  setShowCancelPopup(false);
  setActiveGroup(null);
};

const handleNextPage = () => {
  if (currentPage < totalPages) {
    setCurrentPage(prev => prev + 1);
  }
};

const handlePreviousPage = () => {
  if (currentPage > 1) {
    setCurrentPage(prev => prev - 1);
  }
};


const handleSearch = (query, type) => {
  if (!type && query === '') {
    setFilteredOrders(orders); 
    setCurrentPage(1); 
    return;
  }
  const lowercaseQuery = (query || '').toLowerCase(); 
  const filtered = orders.filter((order) => {
    switch (type) {
      case 'Order Number':
        return order.orderNumber?.toLowerCase().includes(lowercaseQuery);
      case 'Status':
        return order.status?.toLowerCase().includes(lowercaseQuery);
      case 'Customer Name':
        return order.customerName?.toLowerCase().includes(lowercaseQuery);
      default:
        return true; 
    }
  });
  setFilteredOrders(filtered);
  setCurrentPage(1); 
};

// CONFIRM CANCEL
/* const confirmCancelGroup = () => {
  setShowCancelPopup(false);
}; */
const confirmCancelGroup = async () => {
  try {
    const idsToCancel = selectedGroups.length > 0
      ? selectedGroups
      : activeGroup
        ? [activeGroup._id || activeGroup.groupId]
        : [];

    if (idsToCancel.length === 0) {
      closeCancelPopup();
      return;
    }

    const payload = { 
      salesorder_id: orderId,
      delivery_group_ids: idsToCancel, 
      reason: 'Cancelled from admin UI' 
    };

        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

    const response = await fetch(`${API_BASE}/cancel-salesorder-or-deliverygroup`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify(payload)
    });

    const result = await response.json();   // ⬅ FIXED

    if (result.success) {
      setDeliveryGroups(prev =>
        prev.map(g => {
          const id = g._id || g.groupId;
          if (idsToCancel.includes(id)) {
            return { ...g, delivery_group_status: 'Cancelled', status: 'Cancelled' };
          }
          return g;
        })
      );

      setSelectedGroups([]);
      closeCancelPopup();
    } else {
      console.error('Cancel failed', result);
      closeCancelPopup();
    }
  } catch (err) {
    console.error('Error cancelling groups', err);
    closeCancelPopup();
  }
};


// OPEN SLOT POPUP
const openSlotPopup = (group) => {
  setActiveGroup(group);
  setShowSlotPopup(true);
};

// CLOSE SLOT POPUP
const closeSlotPopup = () => {
  setShowSlotPopup(false);
  setSlotDate("");
  setSlotTime("");
  setActiveGroup(null);
};

// Generate Delivery Link
const handleGenerateDeliveryLink = async (group) => {
  try {
    const DG_id = group._id || group.groupId || group.delivery_group_id;
    if (!DG_id) return;
    setGenerateLinkLoading(true);
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

    const res = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}fulfillment/generate-delivery-link`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify({ DG_id })
    });

    const json = await res.json();

    // Normalized link location depending on response format
    const link = json?.data?.delivery_link || json?.delivery_link || (json && json.data && json.data.delivery_link);

    if (res.ok && link) {
      setGeneratedDeliveryLink(link);
      setShowShareLinkPopup(true);
      setCopiedDeliveryLink(false);
      setShowPopup(true);
      setPopupType('200or201');
      setPopupMessage('Delivery link generated. Click "Copy link" to copy.');
      // Auto close toast after 2s
      setTimeout(() => {
        setShowPopup(false);
        setPopupType('');
      }, 2000);
    } else {
      console.error('Failed to generate delivery link', json);
      setShowPopup(true);
      setPopupType('400');
      setPopupMessage(json?.message || 'Unable to generate delivery link');
    }
  } catch (err) {
    console.error('Error generating delivery link:', err);
    setShowPopup(true);
    setPopupType('500');
    setPopupMessage('Internal server error while generating link');
  } finally {
    setGenerateLinkLoading(false);
  }
};

// Copy to Clipboard for share popup
const handleCopyDeliveryLink = async () => {
  try {
    if (!generatedDeliveryLink) return;
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(generatedDeliveryLink);
      setCopiedDeliveryLink(true);
      setTimeout(() => setCopiedDeliveryLink(false), 2000);
    } else {
      // Fallback: create temp input
      const el = document.createElement('textarea');
      el.value = generatedDeliveryLink;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      setCopiedDeliveryLink(true);
      setTimeout(() => setCopiedDeliveryLink(false), 2000);
    }
  } catch (err) {
    console.error('Copy failed', err);
  }
};

// SAVE SLOT UPDATE
/* const saveSlotUpdate = () => {
 
  setShowSlotPopup(false);
}; */

const saveSlotUpdate = async () => {
  try {
    if (!activeGroup) return;

    const delivery_grouping_id = activeGroup._id || activeGroup.groupId;

    const payload = {
      delivery_grouping_id,
      delivery_date: slotDate || undefined,
      delivery_slot: slotTime || undefined
    };

        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

    const response = await fetch(`${API_BASE}/update-delivery-grouping`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify(payload)
    });

    const result = await response.json(); // ⬅⬅⬅ FIXED

    if (result.success) {
      const updated = result.data;

      setDeliveryGroups(prev =>
        prev.map(g => {
          const id = g._id || g.groupId;
          if (String(id) === String(updated._id || updated.groupId)) {
            return { ...g, ...updated };
          }
          return g;
        })
      );

      setShowSlotPopup(false);
      setSlotDate('');
      setSlotTime('');
      setActiveGroup(null);
    } else {
      console.error('Failed to update slot', result); // ⬅ Now prints correct error
      setShowSlotPopup(false);
    }

  } catch (err) {
    console.error('Error saving slot update', err);
    setShowSlotPopup(false);
  }
};

  // ✅ Fetch Orders from API
  const fetchOrders = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/salesorder/get-all-customer-orders`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );
      const resData = await response.json();
      if (resData.success) {
        setOrders(resData.data);
        setFilteredOrders(resData.data);
      } else {
        setError("Failed to fetch orders");
      }
    } catch (err) {
      console.error("Error fetching orders:", err.message);
      setError("Network error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  // Auto-select share link input when popup opens
  useEffect(() => {
    if (showShareLinkPopup) {
      setTimeout(() => {
        shareLinkInputRef.current?.select?.();
        shareLinkInputRef.current?.focus?.();
      }, 50);
    }
  }, [showShareLinkPopup]);


  // State for order summary popup
  const [orderSummaryPopupOpen, setOrderSummaryPopupOpen] = useState(false);
  const [orderSummary, setOrderSummary] = useState(null);
  const [orderSummaryLoading, setOrderSummaryLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("Order Summary");
  const [showBuildcoinsPopup, setShowBuildcoinsPopup] = useState(false);
  // BuildCoins modal state
  const [coinsToGive, setCoinsToGive] = useState("");
  const [crediting, setCrediting] = useState(false);
  // Credit result popup state
  const [creditResult, setCreditResult] = useState({ success: false, message: '' });
  const [showCreditResult, setShowCreditResult] = useState(false);
  const [customerId, setCustomerId] = useState(null);
  const [showSuppliersPopup, setShowSuppliersPopup] = useState(false);
  const [suppliersData, setSuppliersData] = useState([]);
    const [showPreview, setShowPreview] = useState(false);
    const [subOrderData, setSubOrderData] = useState(null);

useEffect(() => {
  if (activeTab !== "delivery") {
    setSelectedGroups([]);
  }
}, [activeTab]);


  useEffect(() => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    setPaginatedOrders(filteredOrders.slice(start, end));
}, [filteredOrders, currentPage]);

const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

  // Function to fetch and open popup
    const handleViewOrderSummary = async (orderId,order) => {
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

    setCustomerId(order.customerId);
    setOrderId(orderId);  
    setOrderSummaryLoading(true);
    setOrderSummaryPopupOpen(true);
    setActiveTab("Order Summary");
    try {
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/salesorder/get-order-summary?orderId=${orderId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'x-token': token}
      });
      const data = await response.json();
      if (data.success) {
        setOrderSummary(data.data);
      } else {
        setOrderSummary(null);
        console.error('Failed to fetch order summary');
      }
    } catch (error) {
      setOrderSummary(null);
      console.error('Error fetching order summary:', error);
    } finally {
      setOrderSummaryLoading(false);
    }
  };

  const fetchDeliveryGroupsForSalesOrder = async (salesorderId) => {
  try {
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

    const headers = { 'Content-Type': 'application/json',
      'x-token': token
     };

    const res = await fetch(`${API_BASE}/get-delivery-groups-by-salesorder?salesorder_id=${salesorderId}`, {
      method: 'GET', 
      headers,
    });

    const data = await res.json();
    
    if (data && data.success) {
      console.log('Fetched delivery groups:', data.data);
      setDeliveryGroups(data.data || []);
    } else {
      console.error('Failed to load delivery groups:', data?.message);
      setDeliveryGroups([]);
    }
  } catch (err) {
    console.error('Error fetching delivery groups:', err);
    setDeliveryGroups([]);
  }
};

  // Fetch delivery groups when tab changes to "Delivery Grouping"
  useEffect(() => {
    if (activeTab === "Delivery Grouping" && orderId) {
      console.log('Fetching delivery groups for sales order:', orderId);
      fetchDeliveryGroupsForSalesOrder(orderId);
    }
  }, [activeTab, orderId]);

// API call for crediting BuildCoins
const creditOrderCoins = async (consumerId, orderId, coinsAmount) => {
  try {
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

    const headers = {
       'Content-Type': 'application/json',
      'x-token': token
     };
    
    
    const res = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/credit-order-coins`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ consumer_id: consumerId, order_id: orderId, coins_amount: coinsAmount })
    });
    
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    
    return await res.json();
  } catch (error) {
    console.error('Error crediting coins:', error);
    return { success: false, message: error.message };
  }
};

// Handler invoked when admin clicks Give in the BuildCoins popup
const handleGiveCoins = async () => {
  if (!coinsToGive || Number(coinsToGive) <= 0) {
    console.error('Enter a valid BuildCoins amount');
    return;
  }

  const consumerId = customerId;
  if (!consumerId) {
    console.error('Consumer id not available on orderSummary');
    return;
  }

  setCrediting(true);
try {
  const res = await creditOrderCoins(consumerId, orderId, Number(coinsToGive));

  const wasSuccessful = (res && (res.success === true || res.total_credited > 0));
  if (wasSuccessful) {
    console.log("BuildCoins credited successfully", res);
    setCreditResult({ success: true, message: res.message || `Credited ${res.total_credited || coinsToGive} BuildCoins` });
    setShowPopup(false);
    setCoinsToGive("");
  } else {
    console.error("Failed to credit BuildCoins", res);
    setCreditResult({ success: false, message: (res && (res.message || JSON.stringify(res))) || 'Failed to credit BuildCoins' });
  }
  setShowCreditResult(true);
  // Auto-close after 3s
  setTimeout(() => setShowCreditResult(false), 3000);
} catch (err) {
  console.error("Error during credit operation", err);
  setCreditResult({ success: false, message: err.message || 'Error during credit operation' });
  setShowCreditResult(true);
  setTimeout(() => setShowCreditResult(false), 3000);
} finally {
  setCrediting(false);
}

};

const openShiftPopup = (group) => {
  setSelectedGroupForShift(group);
  setShiftToValue(
    group.is_delivered_by_brickbucket ? "Brickbucket" : "Customer"
  );
  setShiftPopupVisible(true);
};

const updateShiftAPI = async (groupId, shiftValue) => {
  try {
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

    const response = await fetch(`${API_BASE}/update-delivery-grouping`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" ,
         'x-token': token
      },
      body: JSON.stringify({
        delivery_grouping_id: groupId,
        is_delivered_by_brickbucket: shiftValue === "Brickbucket"
      })
    });

    const data = await response.json();
    console.log("Shift update response:", data); 
    return data;
    
  } catch (error) {
    console.log("Shift update error:", error);
    return { success: false };
  }
};



const saveShiftChange = async () => {
  const groupId = selectedGroupForShift._id;

  const res = await updateShiftAPI(groupId, shiftToValue);

  if (res.success) {
    // Update UI instantly
    setDeliveryGroups(prev =>
      prev.map(g =>
        g._id === groupId
          ? { ...g, is_delivered_by_brickbucket: shiftToValue === "Brickbucket" }
          : g
      )
    );
  }

  setShiftPopupVisible(false);
};

const handleGenerateBill = async () => {
  // Ensure we have at least one selected group
  if (!selectedGroups || selectedGroups.length === 0) {
    setPopupType('400');
    setPopupMessage("Please select at least one group to generate the bill.");
    setShowPopup(true);
    return;
  }

  try {
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}bill/award-order-and-generate-bills`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify({
          delivery_group_ids: selectedGroups, 
        }),
      }
    );

    console.log("body sent:", { delivery_group_ids: selectedGroups });
    const data = await response.json();
    console.log("Generate Bill Response:", data);

   if (data.success) {
      setPopupType('200or201');
      setPopupMessage("Bill generated successfully!");
      setShowPopup(true);
       setTimeout(() => {
          setShowPopup(false);
        }, 3000);
          setSelectedGroups([]);   
      fetchDeliveryGroupsForSalesOrder(orderId);
    } else {
      setPopupType('400');
      setPopupMessage(data.message || "Failed to generate bill");
      setShowPopup(true);
    }
  } catch (error) {
    console.error("Generate Bill Error:", error);
    setPopupType('500');
    setPopupMessage("Something went wrong. Try again!");
    setShowPopup(true);
  }
};

const handleViewBill = async (subOrder) => {
  try {
    const poId = subOrder.purchaseorder_id;

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}bill/get-bill-by-suborder-number?po_id=${poId}`
    );

    const data = await response.json();
    console.log("Fetch Bill Response:", data);

    if (data.success) {
      setBillData(data.data);              
      setBillNumber(data.data.bill_number) 
      setEditBill(false);   
      setBillPopup(true);                
    } else {
      setPopupType('400');
      setPopupMessage("Bill not found");
      setShowPopup(true);
    }
  } catch (error) {
    console.error("Error fetching bill:", error);
    setPopupType('500');
    setPopupMessage("Something went wrong!");
    setShowPopup(true);
  }
};

const updateBillNumber = async () => {
  try {
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}bill/update-bill`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        },
        body: JSON.stringify({
          billId: billData._id,
          updateData: { bill_number: billNumber }
        })
      }
    );

    const result = await response.json();

   if (result.success) {
      setPopupType('200or201');
      setPopupMessage("Bill Number updated Successfully!");
      setBillPopup(false);
      setShowPopup(true);
      setTimeout(() => {
          setShowPopup(false);
        }, 3000);
    } else {
      setPopupType('400');
      setPopupMessage(result.message);
      setShowPopup(true);
    }
  } catch (err) {
    console.error("Update bill error:", err);
    setPopupType('500');
    setPopupMessage("Something went wrong!");
    setShowPopup(true);
  }
};

const truncateFileName = (name, maxLen = 30) => {
  if (!name) return "";
  if (name.length <= maxLen) return name;
  const dotIdx = name.lastIndexOf(".");
  const ext = dotIdx !== -1 ? name.slice(dotIdx) : "";
  const base = dotIdx !== -1 ? name.slice(0, dotIdx) : name;
  const visible = Math.max(6, Math.floor((maxLen - ext.length - 3) / 2));
  return `${base.slice(0, visible)}...${base.slice(-visible)}${ext}`;
};

const handleGenerateInvoice = async (subOrder) => {
  try {
    console.log("Generate Invoice Clicked For:", subOrder);

    const poId = subOrder?.purchaseorder_id;

    if (!poId) {
      console.error("No Purchase Order ID found!");
      return;
    }

    // ✅ EXACT FORMAT backend requires
    const bodyPayload = {
      po_ids: [poId],
    };

    console.log("Sending Payload:", bodyPayload);
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}invoice/create-invoices-for-order-using-poids`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify(bodyPayload),
      }
    );

    const data = await response.json();
    console.log("Generate Invoice API Response:", data);

  if (data.success) {
      setPopupType('200or201');
      setPopupMessage("Invoice generated successfully!");
      setShowPopup(true);
       setTimeout(() => {
          setShowPopup(false);
        }, 3000);
         fetchDeliveryGroupsForSalesOrder(orderId);
    } else {
      setPopupType('400');
      setPopupMessage(data.message || "Failed to generate invoice");
      setShowPopup(true);
    }
  } catch (error) {
    console.error("Generate Invoice Error:", error);
    setPopupType('500');
    setPopupMessage("Something went wrong!");
    setShowPopup(true);
  }
};

const handleSuppliers = () => {
  console.log("Suppliers Clicked:", orderSummary);
  if (!orderSummary.summary || !orderSummary?.summary?.Suppliers) {
    console.log("No supplier data available.");
    return;
  }
  setSuppliersData(orderSummary.summary.Suppliers);
  setShowSuppliersPopup(true);
};

const handleViewInvoice = async (subOrder) => {
  try {
    const poId = subOrder?.purchaseorder_id;
    console.log("View Invoice Clicked For PO ID:", poId);

    if (!poId) {
      console.error("No Purchase Order ID found!");
      setPopupType('400');
      setPopupMessage("No Purchase Order ID found!");
      setShowPopup(true);
      return;
    }

        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

    // Fetch invoice
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}invoice/get-invoice-by-poid?po_id=${poId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const data = await response.json();
    console.log("View Invoice API Response:", data);

    if (data.success && data.data) {
      const invoice = data.data;

     if (!invoice.files || invoice.files.length === 0) {
        setPopupType('400');
        setPopupMessage("No files found in invoice!");
        setShowPopup(true);
        return;
      }


      // Find FIRST PDF file
      const pdfFile = invoice.files.find(file =>
        file.toLowerCase().endsWith(".pdf")
      );
 if (!pdfFile) {
        setPopupType('400');
        setPopupMessage("No PDF file found in invoice!");
        setShowPopup(true);
        return;
      }

      // Build URL
      const pdfUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + pdfFile;

      console.log("Opening PDF:", pdfUrl);

      // OPEN PDF IN NEW TAB 🚀
      window.open(pdfUrl, "_blank");

   } else {
      setPopupType('400');
      setPopupMessage(data.message || "Failed to fetch invoice");
      setShowPopup(true);
    }
  } catch (error) {
    console.error("View Invoice Error:", error);
    setPopupType('500');
    setPopupMessage("Something went wrong!");
    setShowPopup(true);
  }
};


const handleAddChip = (query, type) => {
  if (!type) return;

  const actualQuery = query.trim();

  setSearchChips((prev) => {
    const exists = prev.some(
      (chip) => chip.query === actualQuery && chip.type === type
    );
    if (exists) return prev;

     const updated = [...prev, { query: actualQuery, type }];
    localStorage.setItem('ordersSearchChips', JSON.stringify(updated));
    return updated;
  });
setPersistedSearchQuery(actualQuery);
  setPersistedSearchType(type);
  handleSearch(actualQuery, type);
};


const handleRemoveSearchChip = (chipToRemove) => {
  const updatedChips = searchChips.filter(
    (chip) => !(chip.query === chipToRemove.query && chip.type === chipToRemove.type)
  );
  setSearchChips(updatedChips);
  sessionStorage.setItem('ordersSearchChips', JSON.stringify(updatedChips)); // <-- Use unique key

  if (updatedChips.length === 0) {
    setFilteredOrders(orders);
    setPersistedSearchQuery('');
    setPersistedSearchType('');
    return;
  }

  const last = updatedChips[updatedChips.length - 1];
  handleSearch(last.query, last.type);
};

const handleChipClick = (chip) => {
  setPersistedSearchQuery(chip.query);
  setPersistedSearchType(chip.type);
  handleSearch(chip.query, chip.type);
};

const formatAmount = (value) => {
  if (!value) return "--";
  return Number(value).toLocaleString("en-US");
};


if (loading) {
  return <Loader />;
}


const canShowDeliveryLink = (group) => {
  return group.sub_orders?.some(
    sub =>
      sub.billing_status === "Billed" &&
      sub.status === "Shipped"
  );
};

  // 🧾 MAIN TABLE UI (adapted from RFQsTable)
  return (
    <div className="bg-white min-h-screen w-full ">
      <div className="max-w-full mx-auto">
        <div className="flex space-x-10 py-3 items-center  border-b border-gray-200">
          <h2 className="text-lg font-bold whitespace-nowrap px-3">Customer Orders</h2>
          <div className="flex items-center gap-3">

       <Search
  searchQuery={persistedSearchQuery}
  setSearchQuery={setPersistedSearchQuery}
  searchType={persistedSearchType}
  setSearchType={setPersistedSearchType}
  searchTypes={searchTypes}
  onSearch={handleSearch}
  onSearchSubmit={handleAddChip}
  placeholder="Search orders..."
/>

<div className="flex flex-row items-center gap-3  whitespace-nowrap">
  {searchChips.map((chip, index) => {
    const active = chip.type === persistedSearchType;

    return (
      <div
        key={index}
        onClick={() => handleChipClick(chip)}
        className={`flex items-center px-3 py-1 rounded-full text-sm shadow-sm whitespace-nowrap ${
          active ? 'bg-red-500 text-white' : 'bg-gray-100 text-gray-800'
        }`}
      >
        <span className="font-regular">
          {chip.type}
        </span>

        <button
          className="ml-2 font-bold"
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveSearchChip(chip);
          }}
        >
          ×
        </button>
      </div>
    );
  })}
</div>
          </div>

        </div>
      
<Pagination
    currentPage={currentPage}
    totalPages={totalPages}
    totalItems={filteredOrders.length}
    itemsPerPage={10}
    onPageChange={setCurrentPage}
    showInfo={true}
    hideControls={true} 
    itemName="orders"
/>

        <div className="bg-white">
         
          { error ? (
            <div className="flex flex-col justify-center items-center py-10 text-gray-500">
              <Inbox size={60} className="mb-4 text-gray-400" />
              <p className="text-lg font-medium">Error loading orders</p>
              <p className="text-sm text-gray-400 mt-1">{error}</p>
            </div>
          ) : orders?.length === 0 ? (
            <div className="flex flex-col justify-center items-center h-[100vh] text-gray-500">
              <Inbox size={60} className="mb-4 text-gray-400" />
              <p className="text-lg font-medium">No orders found</p>
              <p className="text-sm text-gray-400 mt-1">Once orders are placed, they will appear here.</p>
            </div>
          ) : (
             <div className="overflow-x-auto overflow-y-auto no-scrollbar min-h-[70vh] max-h-[70vh] ">
              <table className="min-w-full text-sm text-gray-700 mb-5">
                <thead className="bg-[#fafafc] text-[#6c7184] border-b sticky top-0 text-xs font-semibold uppercase">
                  <tr>
                    <th className="px-4 py-4 text-center">Order #</th>
                    <th className="px-4 py-4 text-center">Order Date</th>
                    <th className="px-4 py-4 text-center">Status</th>
                    <th className="px-4 py-4 text-center">Delivery Date</th>
                      <th className="px-4 py-4 text-center">Delivery Slot</th>
                  {/*   <th className="px-4 py-4 text-center">Items Count</th>
                    <th className="px-4 py-4 text-center">Suppliers Count</th> */}
                    <th className="px-4 py-4 text-center">Customer</th>
                  </tr>
                </thead>
                <tbody className="border-b border-gray-200">
                  {filteredOrders.length === 0 ? (
                              <tr>
                                <td colSpan="10" className="text-center py-8">
                                  <div className="flex flex-col items-center">
                                    <FontAwesomeIcon
                                      icon={faSearch}
                                      className="text-4xl text-gray-300 mb-4"
                                    />
                                    <p className="text-lg font-medium mb-2 text-gray-700">
                                      No result found.
                                    </p>
                                    <p className="text-sm text-gray-500">
                                      Try adjusting your search criteria.
                                    </p>
                                  </div>
                                </td>
                              </tr>
                  
                            ) : (
                  paginatedOrders.map((order) => {
              const orderDate = new Date(order.orderDate);
              const datePart = orderDate.toLocaleDateString("en-IN", {
                year: "numeric",
                month: "short",
                day: "numeric",
              });
              const timePart = orderDate.toLocaleTimeString("en-IN", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
              });
                    return (
                      <tr key={order._id} className="hover:bg-blue-50 transition-colors border-b border-gray-200">
                        <td className="px-4 py-3 text-center font-medium text-blue-600 hover:underline cursor-pointer"
                          onClick={() => handleViewOrderSummary(order._id,order)}
                        >{order.orderNumber}</td>
                        <td className="px-4 py-3 text-center">
                          <span className="font-semibold text-gray-900">{datePart}</span>
                          <br />
                          <span className="text-xs text-gray-500">{timePart}</span>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <span className="px-2 py-1 rounded-full border text-xs font-medium bg-green-100 text-green-700 border-green-300">
                            {order.status}
                          </span>
                        </td>
                        <td className="px-4 py-3 text-center">
                          {order.deliveryDate ? (
                            <>
                              <span className="font-semibold text-gray-900">{order.deliveryDate}</span>
                              <br />
                             {/*  <span className="text-xs text-gray-500">{order.deliverySlot}</span> */}
                            </>
                          ) : (
                            "--"
                          )}
                        </td>
                         <td className="px-4 py-3 text-center">
                        <span className="text-xs text-gray-500">{order.deliverySlot}</span>
                         </td>
                        {/* <td className="px-4 py-3 text-center">{order.itemsCount}</td>
                        <td className="px-4 py-3 text-center">{order.totalSuppliersCount}</td> */}
                        <td className="px-4 py-3 text-center">
                          <p className="font-medium text-gray-800">{order.customerName || "--"}</p>
                          <p className="text-xs text-gray-500">{order.customerMobile || ""}</p>
                        </td>
                      </tr>
                   );
                  })
                  )}
                </tbody>
              </table>
            </div>  
          )}
        </div>
         
      </div>
      <div className="sticky bottom-0 bg-white  z-10 px-4 py-2">

              <Pagination
    currentPage={currentPage}
    totalPages={totalPages}
    totalItems={filteredOrders.length}
    itemsPerPage={itemsPerPage}
    onPageChange={setCurrentPage}
    onPreviousPage={handlePreviousPage}
    onNextPage={handleNextPage}
    showInfo={false}
    itemName="orders"
/>
</div>

      {/* 🧾 Order Summary Popup (Adapted from RFQ Details Popup) */}
      {orderSummaryPopupOpen && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
          <div className="bg-white w-full max-w-5xl rounded-xl shadow-2xl relative p-6">
            {/* Header */}
            <div className="flex justify-between items-center border-b pb-3 mb-4">
              <h2 className="text-xl font-bold text-gray-800 flex items-center">
                <Package className="mr-2 text-blue-600" /> {orderSummary?.summary?.orderNumber + " "} Details
              </h2>
    {/* CLOSE BUTTON */}
    <button
      onClick={() => setOrderSummaryPopupOpen(false)}
      className="text-gray-400 hover:text-red-600"
    >
      <X size={22} />
    </button>
            </div>

            {/* Tabs */}
            <div className="flex border-b mb-4">
              {["Order Summary", "items", "customer", "Delivery Grouping"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-4 py-2 font-medium text-sm capitalize border-b-2 transition-colors ${
                    activeTab === tab
                      ? "border-blue-500 text-blue-600"
                      : "border-transparent text-gray-500 hover:text-blue-600"
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div className="max-h-[70vh] overflow-y-auto">
              {/* 📊 Order Summary Tab */}
              {activeTab === "Order Summary" && (
                <>
                  {orderSummaryLoading ? (
                    <div className="flex justify-center items-center py-12 text-gray-500">
                      <Loader2 className="animate-spin mr-2" /> Loading order summary...
                    </div>
                  ) : !orderSummary ? (
                    <div className="flex flex-col justify-center items-center py-16 text-gray-500">
                      <Inbox size={48} className="mb-3 text-gray-400" />
                      <p>No order summary available.</p>
                    </div>
                  ) : (
                    <div className="space-y-6 text-sm text-gray-700">
                      {/* 🧾 Order Summary Header */}
                      <div className="bg-gray-50 border p-4 rounded-lg shadow-sm">
                        <h3 className="text-lg font-semibold text-blue-700 mb-3 flex items-center gap-2">
                          <Package size={18} className="text-blue-600" /> Order Details
                        </h3>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                          <p><span className="font-medium">Order Number:</span> {orderSummary?.summary?.orderNumber}</p>
                          <p><span className="font-medium">Status:</span> {orderSummary?.summary?.status}</p>
                          <p><span className="font-medium">Delivered Status:</span> {orderSummary?.summary?.deliveredStatus}</p>
                          <p><span className="font-medium">Items :</span> {orderSummary?.summary?.itemsCount}</p>
                          <p className="font-medium">
                              Suppliers:
                              <span
                                onClick={handleSuppliers}
                                className="text-blue-600 cursor-pointer hover:underline ml-1"
                              >
                                {orderSummary?.summary?.suppliersCount}
                              </span>
                            </p>

                        </div>
                      </div>

                      {/* 🕒 Simple Timeline */}
                      <div className="relative border-l-2 border-gray-200 pl-6 ml-2">
                        <div className="mb-8 relative">
                          <span className="absolute -left-[14px] top-1 w-3 h-3 rounded-full bg-green-500"></span>
                          <div className="bg-gray-50 border p-4 rounded-lg shadow-sm hover:shadow-md transition">
                            <h4 className="font-semibold text-gray-800 flex items-center gap-2">
                              Order Placed
                              <CheckCircle2 size={16} className="text-green-600" />
                            </h4>
                            <p className="text-gray-600 text-sm mt-1">Order was placed and payment received.</p>
                            <p className="text-xs text-gray-400 mt-2">
                              {new Date(orderSummary?.summary?.orderPlacedDate).toLocaleString()}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* 💰 Pricing Summary */}
                      <div className="bg-gray-50 border p-4 rounded-lg shadow-sm">
                        <h3 className="text-lg font-semibold text-blue-700 mb-3 flex items-center gap-2">
                          <DollarSign size={18} className="text-blue-600" /> Pricing Summary
                        </h3>
                       <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                          <p><span className="font-medium">Subtotal:</span>₹{formatAmount(orderSummary?.summary?.subtotal)}</p>
                          <p><span className="font-medium">Tax:</span>₹{formatAmount(orderSummary?.summary?.tax)}</p>
                          <p><span className="font-medium">Discount:</span> ₹{orderSummary?.summary?.discount || '--'}</p>
                          <p><span className="font-medium">Total:</span> ₹{formatAmount(orderSummary?.summary?.total)}</p>
                        </div>
                       <div className="mt-2 flex justify-end">
                         <button
                       className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow active:scale-[0.97]"
                       onClick={() => setShowBuildcoinsPopup(true)}
                          >                     
                           Give BuildCoins
                       </button>

                    </div>
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* 🧱 Items Tab */}
              {activeTab === "items" && (
                <>
                  {orderSummaryLoading ? (
                    <div className="flex justify-center items-center py-10 text-gray-500">
                      <Loader2 className="animate-spin mr-2" /> Loading items...
                    </div>
                  ) : !orderSummary?.items || orderSummary?.items?.length === 0 ? (
                    <div className="flex flex-col justify-center items-center py-16 text-gray-500">
                      <Inbox size={50} className="mb-3 text-gray-400" />
                      <p className="text-lg font-medium">No items found.</p>
                    </div>
                  ) : (
                    <div className="overflow-x-auto">
                      <table className="min-w-full text-sm text-gray-700 border rounded-lg">
                        <thead className="bg-gray-100 text-xs uppercase font-semibold">
                          <tr>
                            <th className="px-4 py-3 text-left">Item Image</th>
                            <th className="px-4 py-3 text-left">Item Name</th>
                            <th className="px-4 py-3 text-left">Quantity</th>
                            <th className="px-4 py-3 text-left">Price</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                          {orderSummary?.items.map((item, index) => (
                            <tr key={index} className="hover:bg-blue-50 transition-colors">
                              <td className="px-4 py-3">
                                {item.item_image ? (
                                  <img
                                    src={imageurl + item.item_image}
                                    alt={item.item_name || "Item"}
                                    className="w-12 h-12 object-cover rounded-md border"
                                  />
                                ) : (
                                  <div className="w-12 h-12 bg-gray-100 flex items-center justify-center rounded-md">
                                    <Package className="text-gray-400" size={18} />
                                  </div>
                                )}
                              </td>
                              <td className="px-4 py-3">{item.item_name || "--"}</td>
                              <td className="px-4 py-3">{item.quantity}</td>
                              <td className="px-4 py-3"> ₹{formatAmount(item.selling_price)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              )}

              {/* 👤 Customer Tab */}
              {activeTab === "customer" && (
                <>
                  {orderSummaryLoading ? (
                    <div className="flex justify-center items-center py-12 text-gray-500">
                      <Loader2 className="animate-spin mr-2" /> Loading customer info...
                    </div>
                  ) : !orderSummary?.customer ? (
                    <div className="flex flex-col justify-center items-center py-16 text-gray-500">
                      <Inbox size={48} className="mb-3 text-gray-400" />
                      <p>No customer information found.</p>
                    </div>
                  ) : (
                    <div className="space-y-6 text-sm text-gray-700">
                      {/* 👤 Customer Section */}
                      <div className="bg-gray-50 border p-4 rounded-lg shadow-sm">
                        <h3 className="text-lg font-semibold text-blue-700 mb-3 flex items-center gap-2">
                          <User size={18} className="text-blue-600" /> Customer Info
                        </h3>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                          <p><span className="font-medium">Name:</span> {orderSummary.customer.name}</p>
                          <p><span className="font-medium">Company:</span> {orderSummary.customer.company_name}</p>
                          <p><span className="font-medium">Email:</span> {orderSummary.customer.email}</p>
                          <p><span className="font-medium">Mobile:</span> {orderSummary.customer.mobile}</p>
                                                     <p><span className="font-medium">Alternate:</span> {orderSummary.customer.alternate_mobile || "--"}</p>
                        </div>
                      </div>

                      {/* 🏗 Project Section */}
                      <div className="bg-gray-50 border p-4 rounded-lg shadow-sm">
                        <h3 className="text-lg font-semibold text-blue-700 mb-3 flex items-center gap-2">
                          <Building size={18} className="text-blue-600" /> Project Info
                        </h3>
                        <div className="grid grid-cols-2 gap-4">
                          <p><span className="font-medium">Project Name:</span> {orderSummary.project.name}</p>
                          <p><span className="font-medium">Location:</span> {orderSummary.project.location}</p>
                        </div>
                      </div>

                      {/* 📦 Delivery Address */}
                      {orderSummary.customer.delivery_address && (
                        <div className="bg-gray-50 border p-4 rounded-lg shadow-sm">
                          <h3 className="text-lg font-semibold text-blue-700 mb-3 flex items-center gap-2">
                            <MapPin size={18} className="text-blue-600" /> Delivery Address
                          </h3>
                          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                            <p><span className="font-medium">Type:</span> {orderSummary.customer.delivery_address.type || "--"}</p>
                            <p><span className="font-medium">Area:</span> {orderSummary.customer.delivery_address.area || "--"}</p>
                            <p><span className="font-medium">City:</span> {orderSummary.customer.delivery_address.city || "--"}</p>
                            <p><span className="font-medium">State:</span> {orderSummary.customer.delivery_address.state || "--"}</p>
                            <p><span className="font-medium">Pincode:</span> {orderSummary.customer.delivery_address.pincode || "--"}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}

              {/* 🚚 Delivery Grouping Tab */}
 
{activeTab === "Delivery Grouping" && (
  <div className="space-y-4">
    {/* Select All Checkbox */}
{(() => {
  const eligibleGroups = deliveryGroups.filter(g => 
    g.sub_orders.every(sub => sub.billing_status !== "Billed")
  );
  return eligibleGroups.length > 0 ? (
    <div className="flex justify-end mb-4 mr-4">
      <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
    
<input
  type="checkbox"
  checked={isSelectAllChecked}
  disabled={notBilledGroupIds.length === 0} // ✅ IMPORTANT
  onChange={() => {
    if (notBilledGroupIds.length === 0) return;

    setSelectedGroups(prev => {
      if (isSelectAllChecked) {
        return prev.filter(id => !notBilledGroupIds.includes(id));
      }

      return notBilledGroupIds;
    });
  }}
/>
        Select All
      </label>
      {/* Show Generate Bill button only if selected groups have NO suborders with billing_status === "Billed" */}
      {selectedGroups.length > 0 && selectedGroups.every(id => {
        const g = deliveryGroups.find(d => d._id === id);
        return g && g.sub_orders.every(sub => sub.billing_status !== "Billed");
      }) && (
        <button
          onClick={handleGenerateBill}
          className="ml-4 bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-semibold"
        >
          Generate Bill
        </button>
      )}
    </div>
  ) : null;
})()}

    {deliveryGroups.map((group) => (
      <div
        key={group._id}
        className="border rounded-lg shadow-sm p-4 bg-gray-50"
      >
        {/* Header + Checkbox */}
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3">
            <input
              type="checkbox"
              checked={selectedGroups.includes(group._id)}
              onChange={() => handleGroupSelection(group._id)}
              className="w-5 h-5"
            />

            <h4 className="font-semibold text-gray-800">
              {group.readable_order_number} - {group.delivery_group_status}
            </h4>
          </div>

          {/* <span className="text-sm text-gray-500">
            {new Date(group.delivery_date).toLocaleDateString()}
          </span> */}
        </div>

       <p className="text-sm text-gray-600 mb-2 flex justify-between items-center w-full">
  <span>
    Customer: {group.customer_name} | Contact: {group.customer_contact}
  </span>

  <span className="font-semibold text-gray-700">
    {group.delivery_group_billing_status ? group.delivery_group_billing_status : "---"}
  </span>
</p>
        
    <p
  className="text-sm text-gray-600 mb-2 flex items-center gap-2 cursor-pointer"
  onClick={() => {
    const lat = group.delivery_location?.lat;
    const lng = group.delivery_location?.lng;
    const address = encodeURIComponent(group.customer_address);

    // ⭐ Opens Google Maps with pin, coordinates AND address label
    const url = `https://www.google.com/maps?q=${lat},${lng} (${address})`;

    window.open(url, "_blank");
  }}
>
  <FontAwesomeIcon icon={faMapMarkerAlt} className="text-red-500" />
  {group.customer_address}
</p>

        
        <div className="text-sm text-gray-600 mb-2 flex items-center space-x-12">
  {/* Delivery Slot Text */}
  <span>
    Delivery Slot: {group.delivery_slot}
  </span>

   <span className="text-sm text-gray-500">
            {new Date(group.delivery_date).toLocaleDateString()}
          </span>

  {/* Change Delivery Slot Button - Inline */}
 {selectedGroups.includes(group._id) && (
        <button
          onClick={() => openSlotPopup(group)}
          className="bg-blue-600 text-white px-3 py-1 rounded-md text-sm"
        >
          Change Delivery Slot
        </button>
      )}

{/* {(group.delivery_group_status === "Ready for Delivery" || group.delivery_group_status === "Items Ready For Pickup") && (
 */} 
    {canShowDeliveryLink(group) && (
  <>
    <button
      onClick={() => handleGenerateDeliveryLink(group)}
      className="rounded-md text-blue-800 underline flex items-center gap-1"
      disabled={generateLinkLoading}
    >
      {generateLinkLoading ? 'Generating...' : 'Generate Delivery Link'}
      <FontAwesomeIcon icon={faLink} className="ml-1" />
    </button>

    {generatedDeliveryLink && (
      <div className="ml-3 text-sm text-gray-700">
        <a
          href={generatedDeliveryLink}
          target="_blank"
          rel="noreferrer"
          className="text-blue-600 hover:underline"
        >
          Open Link
        </a>
        <span className="ml-2">{copiedDeliveryLink ? '(Copied)' : ''}</span>
      </div>
    )}
  </>
)}


</div>


  {/* BILL TO */}
 {!group.sub_orders.some(sub => sub.billing_status === "Billed") && (
  <div className="flex items-center gap-6 mt-2 mb-2">

    <p className="text-sm text-gray-700 whitespace-nowrap">
      <span className="font-semibold">Bill To:</span> Brickbucket
    </p>

    <p className="text-sm text-gray-700 whitespace-nowrap">
      <span className="font-semibold">Ship To:</span>{" "}
      {group.is_delivered_by_brickbucket ? "Brickbucket" : "Customer"}
    </p>

    <button
      className="px-3 py-1 rounded-md bg-blue-600 text-white text-xs font-semibold whitespace-nowrap"
      onClick={() => openShiftPopup(group)}
    >
      Change
    </button>
  </div>
)}


        {/* ORDERS INSIDE */}
        <div className="space-y-2">
          {group.sub_orders && group.sub_orders.map((subOrder) => (
            <div
              key={subOrder._id}
              className="border rounded-md p-3 bg-white shadow-sm"
            >
              <div className="flex justify-between items-center mb-1">
                <p className="font-medium text-gray-800">
                  PO Number: {subOrder.po_number}
                </p>

                <p className="font-semibold text-gray-800">
                  {subOrder.status}
                </p>
              </div>

         <div className="mb-1">
  
  {/* Vendor */}
  <p className="text-sm text-gray-600">
    Vendor: {subOrder.vendor_name || " "}
  </p>

  <p className="text-sm text-gray-600">
    Vendor Mobile: {subOrder.vendor_id?.mobile_number || " "}
  </p>

  {/* Sub Order + View Bill Button (only when billed) */}
  <div className="flex items-center justify-between">
    
    <p className="text-sm text-gray-600">
      Sub Order: {subOrder.readable_sub_order_number}
    </p>

    <p className="text-sm text-gray-600">
      Delivered By: {group.delivered_by}
    </p>

   {/*  {subOrder.billing_status === "Billed" && (
      <button
        className="flex items-center gap-1 text-blue-600 hover:text-blue-800 text-sm"
        onClick={() => handleViewBill(subOrder)}   // You can define this function
      >
        <Eye size={18} />
        View Bill
      </button>
    )} */}
  </div>
</div>

          <div className="flex w-full gap-6">

  {/* LEFT: ONLY ONE IMAGE */}
  <div className="w-28 flex-shrink-0">
    {subOrder.po_images?.length > 0 ? (
      <img
        src={imageurl + subOrder.po_images[0]}
        alt="PO Image"
        onClick={() => {
          setShowPreview(true);
          setSubOrderData(subOrder);
        }}
        className="w-28 h-28 object-cover rounded-lg cursor-pointer hover:opacity-80 border"
      />
    ) : (
      <div className="w-28 h-28 bg-gray-100 border rounded-lg flex items-center justify-center text-xs text-gray-400">
        No Image
      </div>
    )}
  </div>

  {/* MIDDLE: ITEMS LIST */}
  <div className="flex-1">
    <ul className="text-sm text-gray-700 space-y-1">
      {subOrder.items?.map((item, idx) => (
        <li key={idx}>
          {item.item_name} – Qty: {item.quantity}
        </li>
      ))}
    </ul>
  </div>

  {/* RIGHT: BILLING / INVOICE BUTTONS */}
  <div className="flex flex-col items-end gap-2 w-40">

    {subOrder.billing_status === "Billed" && (
      <button
        className="flex items-center gap-1 text-blue-600 hover:text-blue-800 text-sm"
        onClick={() => handleViewBill(subOrder)}
      >
        <Eye size={18} />
        View Bill
      </button>
    )}

    {subOrder.billing_status === "Billed" && subOrder.status !== "Shipped" && (
      <button
        className="flex items-center gap-2 text-green-600 hover:text-green-800 text-sm"
        onClick={() => handleGenerateInvoice(subOrder)}
      >
        <FontAwesomeIcon icon={faFileInvoice} />
        Generate Invoice
      </button>
    )}

    {subOrder.status === "Shipped" && (
      <button
        className="flex items-center gap-2 text-green-600 hover:text-green-800 text-sm"
        onClick={() => handleViewInvoice(subOrder)}
      >
        <FontAwesomeIcon icon={faFileInvoice} />
        View Invoice
      </button>
    )}

  </div>
</div>


            </div>
          ))}
        </div>
        
      </div>
    ))}
  </div>
)}
            </div>
          </div>
        </div>
      )}

    {showBuildcoinsPopup && (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
    <div className="bg-white w-full max-w-md rounded-xl shadow-2xl p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h4 className="font-semibold text-lg">Give BuildCoins</h4>
        <button
          onClick={() => setShowBuildcoinsPopup(false)}
          className="text-gray-500 hover:text-gray-800"
        >
          <X size={20} />
        </button>
      </div>

      {/* Input Field */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Enter BuildCoins
        </label>
        <input
          type="number"
          min="0"
          value={coinsToGive}
          onChange={(e) => setCoinsToGive(e.target.value)}
          className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="0"
        />
      </div>

      {/* Confirm Button */}
      <button
        type="button"
        className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow w-full disabled:opacity-50"
        onClick={handleGiveCoins}
        disabled={crediting || !coinsToGive}
      >
        {crediting ? 'Giving...' : 'Give'}
      </button>
    </div>
  </div>
)}

{showSuppliersPopup && (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
    <div className="bg-white w-full max-w-2xl rounded-xl shadow-2xl p-6">
      
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h4 className="font-semibold text-blue-700 text-xl">Suppliers</h4>
        <button
          onClick={() => setShowSuppliersPopup(false)}
          className="text-gray-500 hover:text-gray-800"
        >
          <X size={22} />
        </button>
      </div>

      {/* Content */}
      <div className="space-y-5">
        {suppliersData && suppliersData.length > 0 ? (
          suppliersData.map((supplier, index) => (
            <div
              key={index}
              className="flex gap-4 border border-gray-200 rounded-lg p-5 shadow-sm hover:shadow-md transition-shadow"
            >
              
              {/* Supplier Image */}
             {supplier.image ? (
              <img
                src={supplier.image}
                alt="Supplier"
                className="w-20 h-20 rounded-lg object-cover border"
              />
            ) : (
              <div className="w-20 h-20 flex items-center justify-center rounded-lg border bg-gray-100">
                <FaStore size={32} className="text-gray-500" />
              </div>
            )}


              {/* Supplier Details */}
              <div className="grid grid-cols-2 gap-y-2 w-full text-sm">
                
                <span className="font-medium text-gray-600">Name:</span>
                <span className="text-gray-900">{supplier.name || "-"}</span>

                <span className="font-medium text-gray-600">Mobile:</span>
                <span className="text-gray-900">{supplier.mobile_number || "-"}</span>

                <span className="font-medium text-gray-600">Company:</span>
                <span className="text-gray-900">{supplier.company_name || "-"}</span>

                <span className="font-medium text-gray-600">Address:</span>
                <span className="text-gray-900">{supplier.address || "-"}</span>

              </div>

            </div>
          ))
        ) : (
          <p className="text-center text-gray-500">No suppliers available.</p>
        )}
      </div>

    </div>
  </div>
)}



{showCreditResult && (
  <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50 p-4">
    <div className={`w-full max-w-sm rounded-lg p-4 shadow-xl ${creditResult.success ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
      <div className="flex items-start gap-3">
        <div className="mt-0.5">
          {creditResult.success ? <CheckCircle className="text-green-600" /> : <X className="text-red-600" />}
        </div>
        <div className="flex-1">
          <p className={`font-semibold ${creditResult.success ? 'text-green-800' : 'text-red-800'}`}>{creditResult.success ? 'Success' : 'Failed'}</p>
          <p className="text-sm text-gray-700 mt-1">{creditResult.message}</p>
        </div>
{/*         <div>
          <button onClick={() => setShowCreditResult(false)} className="text-gray-500 hover:text-gray-800">
            Close
          </button>
        </div> */}
      </div>
    </div>
  </div>
)}

 {showSlotPopup && (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
    <div className="bg-white min-h-[50vh] p-6 rounded-lg w-100 shadow-xl flex flex-col">

      <h3 className="text-lg font-semibold mb-4">Change Delivery Slot</h3>

      {/* DATE INPUT */}
      <div className="mb-4">
        <label className="text-sm font-medium">Select Date</label>
        <input
          type="date"
          value={slotDate}
          onChange={(e) => setSlotDate(e.target.value)}
          className="w-full border px-3 py-2 rounded-md mt-1"
        />
      </div>

      {/* SLOT DROPDOWN */}
      <div className="mb-4">
        <label className="text-sm font-medium">Delivery Slot</label>
        <select
          value={slotTime}
          onChange={(e) => setSlotTime(e.target.value)}
          className="w-full border px-3 py-2 rounded-md mt-1"
        >
          <option value="">Select Slot</option>
          <option value="14:00 PM – 19:00 PM">14:00 PM – 19:00 PM</option>
          <option value="9:30 AM – 13:00 PM">9:30 AM – 13:00 PM</option>
        </select>
      </div>

      {/* FILL SPACE */}
      <div className="flex-grow" />

      {/* BUTTONS */}
      <div className="flex justify-end gap-4">
        <button
          onClick={closeSlotPopup}
          className="px-3 py-1 bg-gray-300 rounded-md"
        >
          Cancel
        </button>

        <button
          onClick={saveSlotUpdate}
          className="px-3 py-1 bg-red-500 text-white rounded-md"
        >
          Save
        </button>
      </div>

    </div>
  </div>
)}

 {/* IMAGE PREVIEW MODAL */}
{showPreview && (
  <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-2">
    <div className="bg-white rounded-xl p-1 w-full max-w-4xl relative shadow-xl">

      {/* Close Button */}
      <button
        onClick={() => setShowPreview(false)}
        className="absolute top-2 right-3 text-gray-700 text-xl font-bold hover:text-black"
      >
        ✕
      </button>

      {/* Title */}
      <h2 className="text-lg font-semibold text-gray-800 mb-4 text-center">
        PO Images
      </h2>

      {/* Image Container */}
      <div
        className={`flex ${
          subOrderData.po_images.length > 1 ? "overflow-x-auto gap-6" : "justify-center"
        } py-4`}
        style={{ scrollSnapType: "x mandatory" }}
      >
        {subOrderData.po_images.map((img, idx) => (
          <div
            key={idx}
            className="min-w-[300px] max-w-[300px] scroll-snap-align-start flex justify-center"
          >
            <img
              src={imageurl + img}
              className="max-h-[450px] rounded-lg object-contain border shadow-md"
              alt="PO Full View"
            />
          </div>
        ))}
      </div>


     
    </div>
  </div>
)}


{/* Share Delivery Link Popup */}
{showShareLinkPopup && (
  <div
    className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4"
    onClick={(e) => { if (e.target === e.currentTarget) setShowShareLinkPopup(false); }}
  >
    <div className="bg-white w-full max-w-md rounded-xl shadow-2xl p-6">
      <div className="flex justify-between items-center mb-3">
        <h4 className="font-semibold text-lg">Share Delivery Link</h4>
        <button
          onClick={() => setShowShareLinkPopup(false)}
          className="text-gray-500 hover:text-gray-800"
          aria-label="Close share popup"
        >
          <X size={20} />
        </button>
      </div>

      <p className="text-sm text-gray-600 mb-3">Share this delivery link with the customer or partner</p>

      <div className="flex items-center gap-2">
        <input
          ref={shareLinkInputRef}
          type="text"
          value={generatedDeliveryLink || ''}
          readOnly
          className="flex-1 border px-3 py-2 rounded-md text-sm bg-gray-50"
        />

        <button
          onClick={handleCopyDeliveryLink}
          className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm"
          disabled={!generatedDeliveryLink}
        >
          Copy
        </button>
      </div>

      <div className="flex justify-between items-center mt-3">
        <a href={generatedDeliveryLink} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline text-sm">Open Link</a>
        <div className="text-sm text-green-600">{copiedDeliveryLink ? 'Copied!' : ''}</div>
      </div>
    </div>
  </div>
)}

 {/* CANCEL POPUP */}
    {showCancelPopup && (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
        <div className="bg-white p-5 rounded-lg w-80 shadow-xl">
          <h3 className="text-lg font-semibold mb-3">
            Are you sure you want to cancel this order?
          </h3>

          <div className="flex justify-end gap-4 ">
            <button
              onClick={closeCancelPopup}
              className="px-3 py-1 bg-gray-300 rounded-md"
            >
              No
            </button>
            <button
              onClick={confirmCancelGroup}
              className="px-3 py-1 bg-red-600 text-white rounded-md"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    )}


   {shiftPopupVisible && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
    <div className="bg-white w-[90%] max-w-sm rounded-lg p-6 shadow-lg min-h-[400px] flex flex-col justify-between">
      
      <div>
        <h3 className="text-lg font-bold text-gray-800 mb-6">Update Shift</h3>

        {/* BILL TO */}
        <div className="mb-6">
          <p className="font-semibold text-gray-700 mb-2">Bill To</p>
          <p className="bg-gray-100 p-3 rounded text-gray-800">Brickbucket</p>
        </div>

        {/* SHIFT TO */}
        <div className="mb-6">
          <p className="font-semibold text-gray-700 mb-2">Ship To</p>
          <select
            value={shiftToValue}
            onChange={(e) => setShiftToValue(e.target.value)}
            className="w-full border rounded p-2"
          >
            <option value="Brickbucket">Brickbucket</option>
            <option value="Customer">Customer</option>
          </select>
        </div>
      </div>

      {/* BUTTONS */}
      <div className="flex justify-end gap-6 border-t border-gray-200 pt-4 mt-4">
  <button
    className="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400 transition"
    onClick={() => setShiftPopupVisible(false)}
  >
    Cancel
  </button>

  <button
    className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
    onClick={saveShiftChange}
  >
    Save
  </button>
</div>

    </div>
  </div>
)}

{billPopup && billData && (
  <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 p-4">
    <div className="bg-white w-full max-w-lg rounded-xl p-6 shadow-2xl">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-5">
        <h2 className="text-xl font-semibold text-gray-800">Bill Details</h2>
        <button
          onClick={() => {
            setBillPopup(false);
            setEditBill(false); // reset edit state so next open shows pencil
          }}
        >
          <X size={24} className="text-gray-500 hover:text-gray-700" />
        </button>
      </div>

      {/* BILL NUMBER row: label + bill no + pencil on same line */}
      <div className="mb-5">
        <label className="text-sm font-medium text-gray-700 block mb-2">Bill Number</label>

        <div className="flex items-center gap-3">
          {/* bill number input (disabled unless editing) */}
          <input
            type="text"
            value={billNumber}
            disabled={!editBill}
            onChange={(e) => setBillNumber(e.target.value)}
            className={`flex-1 px-3 py-2 border rounded-lg ${
              editBill ? "bg-white border-blue-500 text-gray-900" : "bg-gray-100 text-gray-600 cursor-not-allowed border-gray-200"
            }`}
          />


          {/* Pencil edit icon (FontAwesome) - always visible when popup opens */}
        {!editBill && (
  <button
    onClick={() => setEditBill(true)}
    className="text-blue-600 hover:text-blue-800 p-2 rounded"
    title="Edit bill number"
  >
    <FontAwesomeIcon icon={faPencilAlt} />
  </button>
)}
        </div>
      </div>

      {/* FILES SECTION */}
      <div>
        <p className="font-medium mb-3 text-gray-800">Files</p>

        {(!billData.files || billData.files.length === 0) ? (
          <p className="text-gray-500 text-sm">No files uploaded</p>
        ) : (
          <div className="space-y-3">
            {billData.files.map((file, idx) => {
              // file may be a path like "uploads/abc.pdf" or full url; handle both
              const fname = file.split("/").pop();
              const isPDF = fname.toLowerCase().endsWith(".pdf");
              return (
                <div
                  key={idx}
                  className="border p-3 rounded-lg flex items-center justify-between bg-gray-50"
                >
                  <div className="flex items-center gap-3">
                    {/* PDF icon or image preview */}
                    {isPDF ? (
                      <div className="w-10 h-10 flex items-center justify-center rounded bg-red-50">
                        <FontAwesomeIcon icon={faFilePdf} className="text-red-600" />
                      </div>
                    ) : (
                      <img
                        src={imageurl + file}
                        alt={fname}
                        className="w-14 h-14 object-cover rounded"
                        onError={(e) => { e.currentTarget.style.display = 'none'; }}
                      />
                    )}

                    {/* truncated filename */}
                    <div className="flex flex-col">
                      <span className="text-sm font-medium text-gray-800">{truncateFileName(fname, 34)}</span>
                      <span className="text-xs text-gray-500">{isPDF ? "PDF" : "Image"}</span>
                    </div>
                  </div>

                  {/* view link */}
                  <a
                    href={imageurl + file}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 text-sm underline ml-4"
                  >
                    View
                  </a>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* BUTTONS */}
<div className="flex justify-end gap-4 mt-8">

  {/* Show ONLY when editing */}
  {editBill && (
    <>
      <button
        onClick={() => {
          setBillPopup(false);
          setEditBill(false);
        }}
        className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg"
      >
        Cancel
      </button>

      <button
        onClick={updateBillNumber}
        className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg"
      >
        Update
      </button>
    </>
  )}

</div>

    </div>
  </div>
)}


{/* Success and small toasts */}
{showPopup && popupType === '200or201' && (
  <div className="fixed top-4 right-4 z-50 pointer-events-none">
    <div className="pointer-events-auto">
      <Msg200or201 message={popupMessage} timeout={1000} />
    </div>
  </div>
)}

{showPopup && popupType === '204' && (
  <div className="fixed top-4 right-4 z-50">
    <Msg204 message={popupMessage} timeout={1000} />
  </div>
)}

{/* Full-screen modals (errors, auth) - render directly because they have their own overlay */}
{showPopup && popupType === '400' && (
  <div>
    <Msg400 message={popupMessage} closePopup={closePopup} />
  </div>
)}
{showPopup && popupType === '401' && (
  <div>
    <Msg401 message={popupMessage} closePopup={BackToLoginPage} />
  </div>
)}
{showPopup && popupType === '403' && (
  <div>
    <Msg403 message={popupMessage} closePopup={BackToLoginPage} />
  </div>
)}
{showPopup && popupType === '500' && (
  <div>
    <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />
  </div>
)}

    </div>
    
  );
};

export default OrdersTable;